import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { ThumbsUp, Heart } from "lucide-react";
// import { FaThumbsUp, FaHeart } from "react-icons/fa";
import { ADMIN_ID } from "./Constant";

const defaultReactions = {
  like: 0,
  love: 0,
};

const lucideIconMap = { like: ThumbsUp, love: Heart };
const faIconMap = { like: ThumbsUp, love: Heart };

const ReactionBar = ({ blogId }) => {
  const [reactions, setReactions] = useState(defaultReactions);
  const [selected, setSelected] = useState(null);
  const url = API_BASE_URL

  const endpoints = {
    like: `${url}/api/like`,
    love: `${url}/api/heart`,
  };

  const endpointsGet = {
    like: `${url}/api/like/${blogId}`,
    love: `${url}/api/heart/${blogId}`,
  };

  // Load reactions from backend or localStorage
 useEffect(() => {
  if (!blogId) return;

  const fetchReactions = async () => {
    const keys = { like: `reaction_like_${blogId}`, love: `reaction_love_${blogId}` };
    const newReactions = {};

    for (let type of Object.keys(keys)) {
      const storedData = localStorage.getItem(keys[type]);
      if (storedData) {
        const parsed = JSON.parse(storedData);
        newReactions[type] = parsed.count || 0;
        if (parsed.selected) setSelected(type);
      } else {
        try {
          const res = await fetch(endpointsGet[type]);
          const data = res.ok ? await res.json() : { total: 0 };
          newReactions[type] = data.total || 0;
        } catch {
          newReactions[type] = 0;
        }
      }
    }

    setReactions(newReactions);
  };

  fetchReactions();
}, [blogId]);


 const handleReaction = async (type) => {
  try {
    const storedKey = `reaction_${type}_${blogId}`; // separate key per type
    const storedData = localStorage.getItem(storedKey);
    const parsed = storedData ? JSON.parse(storedData) : null;

    // Prevent duplicate click
    if (parsed && parsed.selected) return;

    // Update UI immediately
    setReactions((prev) => ({ ...prev, [type]: (prev[type] || 0) + 1 }));
    setSelected(type);

    // Send to backend
    await fetch(endpoints[type], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ blog_id: blogId, AdminId: ADMIN_ID }),
    });

    // Store separately in localStorage
    localStorage.setItem(
      storedKey,
      JSON.stringify({
        count: (reactions[type] || 0) + 1,
        selected: true,
      })
    );
  } catch (err) {
    console.error(`❌ Failed to handle ${type} reaction:`, err);
  }
};


  return (
    <div className="flex justify-center gap-4 p-3 bg-white">
      {Object.keys(lucideIconMap).map((type) => {
        const LucideIcon = lucideIconMap[type];
        const FaIcon = faIconMap[type];
        const isSelected = selected === type;

        return (
          <button
            key={type}
            onClick={() => handleReaction(type)}
            aria-label={`React with ${type}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
              ${isSelected ? "bg-[#4e59c2] text-white" : "bg-gray-100 hover:bg-[#e2e7f7] text-gray-800"}`}
          >
            {isSelected ? <FaIcon size={18} /> : <LucideIcon size={18} />}
            <span>{reactions[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionBar;
